import { queryOptions } from '@tanstack/react-query';

import { fetchBrands } from './api';
import { BRANDS_CACHE_STALE_TIME } from './constants';

import {
  RQ_BRANDS_KEY,
  RQ_BRAND_BY_SLUG_KEY,
} from '@/modules/ReactQuery/cacheKeys';
import { getBrandPageBySlug } from '@/modules/cms/api';
import { getCMSLocale } from '@/modules/cms/helpers/getCMSLocale';

export function brandsQueryOptions() {
  return queryOptions({
    queryKey: [RQ_BRANDS_KEY],
    queryFn: fetchBrands,
    staleTime: BRANDS_CACHE_STALE_TIME,
  });
}

export function brandPageBySlugQueryOptions(slug: string) {
  const cmsLocale = getCMSLocale();

  return queryOptions({
    queryKey: [RQ_BRAND_BY_SLUG_KEY, { slug, cmsLocale }],
    queryFn: () => getBrandPageBySlug(slug, cmsLocale),
  });
}
